import * as React from "react";
import { useGlobalConfig } from "../../GlobalConfig";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { useAccount } from "../../Account";
import { Alert, Typography } from "@mui/material";
import { useLanguage } from "../../Language";
import { GoogleSignInButton } from "../../GoogleSignInButton";

interface SignUpWithGoogleProps {
  googleId?: string;
}

export const SignUpWithGoogle = ({ googleId }: SignUpWithGoogleProps) => {
  const { googleOauthEnabled } = useGlobalConfig();
  const { locationConfiguration } = useLocationConfiguration();
  const { isAuthenticated } = useAccount();
  const { translate } = useLanguage();

  const showSignUpWithGoogle = React.useMemo(() => {
    if (!googleOauthEnabled) {
      return false;
    }
    if (!locationConfiguration?.pacSettings?.googleSSOEnabled) {
      return false;
    }
    if (isAuthenticated) {
      return false;
    }
    if (!!googleId) {
      return false;
    }
    return true;
  }, [googleOauthEnabled, isAuthenticated, googleId, locationConfiguration]);

  return (
    <>
      {showSignUpWithGoogle && (
        <Alert severity="info" variant="outlined">
          <Typography>{translate("signUpWithGoogleInstructions")}</Typography>
          <GoogleSignInButton
            sx={{ marginTop: 1 }}
            onClick={() => (location.href = "/oauth2/signUpWithGoogle")}
          ></GoogleSignInButton>
        </Alert>
      )}
    </>
  );
};
